import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiButton from "@mui/material/Button";
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

const MyButton = styled(MuiButton)(({ theme }) => ({
  border: 0,
  borderRadius: 100,
  // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  height: 40,
  padding: "13.33px 26.67px",
  // width: 194,
  // justifyContent: "space-between",
  fontSize: 14,
  fontWeight: 500,
  textTransform: "capitalize",
  // [theme.breakpoints.down('md')]: {
  //   height: 30, // Smaller height for medium screens
  //   padding: "10px 20px", // Smaller padding for medium screens
  //   fontSize: 12, // Smaller font size for medium screens
  // },
  // [theme.breakpoints.down('sm')]: {
  //   fontSize: 11,
  // },
  '@media (min-width: 991px)': {
    height: 30,
    padding: "10px 20px",
    fontSize: 12,
  },

  '@media (max-width: 990px)': {
    fontSize: 11,
  },
}));

interface CustomButtonProps {
  children?: React.ReactNode;
  endIconn?: React.ReactNode;
  startIconn?: React.ReactNode;
  background?: any;
  color?: any;
  border?: string,
  sx?: SxProps<Theme>;
  onClick?: (e: any) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export default function Button({
  children,
  onClick,
  endIconn,
  startIconn,
  background = "rgba(246, 51, 63, 1)",
  sx,
  color = "white",
  border ,
  type = 'button',
  disabled,
}: CustomButtonProps) {
  return (
    <Box>
      <MyButton
        onClick={onClick}
        endIcon={endIconn}
        startIcon={startIconn}
        disabled={disabled}
        type={type} //
        sx={{
          border: border,
          background: background,
          color: { color },
          "&:hover": {
            backgroundColor: background,
          },
          ...sx,
        }}
      >
        {children}
      </MyButton>
    </Box>
  );
}
